import { SteelOrder } from "./types";
import { Header } from '../../../../components/SubHeaderFilter/types';

export const getStatusText = (status: boolean | null | undefined): string => {
  if (status === true) return 'Fechada';
  if (status === false) return 'Cancelado';
  return 'Em Aberto';
};

export const formatStatus = (status: boolean | null | undefined): { text: string; status: boolean | null | undefined } => {
  return {
    text: getStatusText(status),
    status: status
  };
};

export const formatDate = (dateString: string | undefined): string => {
  if (!dateString) return 'N/A';
  const date = new Date(dateString);
  return new Intl.DateTimeFormat('pt-BR', { timeZone: 'UTC' }).format(date);
};

export const formatCurrency = (value: number | undefined): string => {
  if (typeof value !== 'number') return 'N/A';
  return value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
};

export const getTotalWeight = (items: SteelOrder['items']): string => {
  if (!items || items.length === 0) return '0.00 kg';

  const totalWeight = items.reduce((sum, orderItem) => {
    const weightStr = orderItem.offeredProduct?.weigth || orderItem.requestedProduct?.weigth;
    const weight = weightStr ? parseFloat(weightStr.replace(',', '.')) : 0;
    return sum + (isNaN(weight) ? 0 : weight);
  }, 0);

  return `${totalWeight.toFixed(2)} kg`;
};

export const steelOrdersTableHeaders: Header[] = [
  { key: 'saleNumberPloomes', label: 'Número do pedido', type: 'number' as const },
  { key: 'npc', label: 'NPC', type: 'string' as const },
  { key: 'client', label: 'Cliente', type: 'string' as const },
  { key: 'orderDate', label: 'Data do pedido', type: 'date' as const },
  { key: 'deliveryDate', label: 'Data de entrega', type: 'date' as const },
  { key: 'totalWeight', label: 'Peso total', type: 'number' as const },
  { key: 'total', label: 'Valor total', type: 'number' as const },
  { key: 'status', label: 'Status', type: 'boolean' as const },
];